import React from 'react';
import { Pie } from 'react-chartjs-2';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { Chart } from 'chart.js';
import {
  ChartContainer,
  CustomLegend,
  LegendColor,
  LegendItem,
  LegendLabel
} from '../../styled';
import { chartPieWithTheLabelsOptions } from 'assets/ChartsLabelsConfigurations/ChartPieDefaultOptions';
import { CardHeader } from 'reactstrap';

Chart.plugins.register(ChartDataLabels);
Chart.defaults.global.plugins.datalabels = false;

const PieChart = ({
  formattedDataProtocols,
  chartTittle = '',
  legendPosition = 'bottom'
}) => {
  const hasData =
    formattedDataProtocols &&
    formattedDataProtocols.arrayLabels &&
    formattedDataProtocols.arrayLabels.length > 0;

  return (
    <ChartContainer>
      <CardHeader style={{ alignSelf: 'baseline' }}>
        <h5 className="h3 mb-0">{chartTittle}</h5>
      </CardHeader>
      {legendPosition === 'top' && (
        <CustomLegend>
          {hasData ? (
            formattedDataProtocols.arrayLabels.map((label, index) => (
              <LegendItem key={index}>
                <LegendColor
                  color={formattedDataProtocols.arrayColors[index]}
                />
                <LegendLabel>{label}</LegendLabel>
              </LegendItem>
            ))
          ) : (
            <p>Nenhum dado disponível</p>
          )}
        </CustomLegend>
      )}
      <div className="chart">
        <Pie
          data={{
            labels: hasData ? formattedDataProtocols.arrayLabels : [],
            datasets: [
              {
                data: hasData ? formattedDataProtocols.arrayData : [],
                backgroundColor: hasData
                  ? formattedDataProtocols.arrayColors
                  : []
              }
            ]
          }}
          options={chartPieWithTheLabelsOptions}
          className="chart-canvas"
          id="chart-doughnut"
        />
      </div>
      {legendPosition === 'bottom' && (
        <CustomLegend>
          {hasData ? (
            formattedDataProtocols.arrayLabels.map((label, index) => (
              <LegendItem key={index}>
                <LegendColor
                  color={formattedDataProtocols.arrayColors[index]}
                />
                <LegendLabel>{label}</LegendLabel>
              </LegendItem>
            ))
          ) : (
            <p>Nenhum dado disponível</p>
          )}
        </CustomLegend>
      )}
    </ChartContainer>
  );
};

export default PieChart;
